import React from 'react';

import LikertQuestionResponse from './LikertQuestionResponse';
import LongTextQuestionResponse from './LongTextQuestionResponse';
import MultiSelectQuestionResponse from './MultiSelectQuestionResponse';
import NullQuestionResponse from './NullQuestionResponse';

const getComponent = (question) => {
  switch (question.type) {
    case 'likert':
    case 'unscored-likert':
      return LikertQuestionResponse;

    case 'long-text':
      return LongTextQuestionResponse;

    case 'single-select':
    case 'multi-select':
      return MultiSelectQuestionResponse;

    default:
      return NullQuestionResponse;
  }
};

function QuestionResponse({ question, response }) {
  const Component = getComponent(question);

  return <Component question={question} response={response} />;
}

export default QuestionResponse;
